<template>
    <div>
        <ul class="list-group small">
            <li v-for="(grant, idx) in grants" :key="idx" class="list-group-item d-flex align-items-center py-0 pe-0 ps-2">
                <alzata-icon :icon="iconForPrincipalTypeId(grant.principalTypeId)" fixed-width />
                <span class="ms-2 me-auto">{{nameForPrincipal(grant.principalTypeId, grant.principalId)}}</span>
                <div class="btn-group btn-group-sm" role="group">
                    <button type="button" class="btn btn-sm btn-default" @click="() => grant.isAllowed = !grant.isAllowed">
                        <alzata-icon :icon="grant.isAllowed ? 'far/toggle-on' : 'far/toggle-off'" />
                    </button>
                    <button type="button" class="btn btn-sm btn-default" :disabled="grant.principalTypeId === null" @click="() => grants.splice(idx, 1)">
                        <alzata-icon icon="far/trash-alt" />
                    </button>
                </div>
            </li>
        </ul>
        <alzata-dropdown class="me-auto text-primary mt-1" size="sm" color="secondary" :items="availableRoles">
            <template v-slot:label>
                <alzata-icon icon="far/plus-circle" fixed-width />
                <span class="mx-2">Add Role...</span>
            </template>
            <template v-slot:item="{item}">
                <li><a class="dropdown-item" href="#" @click="addGrant(item.principalTypeId, item.principalId)">
                    <alzata-icon :icon="iconForPrincipalTypeId(item.principalTypeId)" fixed-width />
                    {{nameForPrincipal(item.principalTypeId, item.principalId)}}
                </a></li>
            </template> 
        </alzata-dropdown>
    </div>    
</template>

<script>
import { mapActions, mapState } from 'vuex';

const roleEntityTypeId = 'd1706a7f-3dd8-4d72-ab2b-2cad4eae4df9';
const userEntityTypeId = '4e14cfc7-c48d-4dde-9384-59fca6f5647b';

export default {
    name: 'AlzataAclEditor',
    props: {
        modelValue: {},
        entityTypeId: String,
        entityId: String,
    },
    emits: ['update:modelValue'],
    data() {
        return {
            grants: [],
        };
    },
    watch: {
        entityTypeId() {
            this.grants = [];
            this.reload();
        },
        entityId() {
            this.grants = [];
            this.reload();
        },
        grants() {
            this.$emit('update:modelValue', this.grants);
        },
    },
    mounted() {
        this.loadRoles();
        this.reload();
    },
    computed: {
        ...mapState({
            allRoles: state => state.iam.allRoles,
        }),
        availableRoles() {
            const possibleGrants = [
                { principalTypeId: null, principalId: null },
                { principalTypeId: userEntityTypeId, principalId: null },
                ...Object.values(this.allRoles || []).map(x => ({ principalTypeId: roleEntityTypeId, principalId: x.id})),
            ].filter(x => this.grants.findIndex(y => y.principalTypeId === x.principalTypeId && y.principalId === x.principalId) < 0);
            return possibleGrants;
        },
        canAddRole() {
            return this.availableRoles.length > 0 && this.grants.filter(x => x.principalTypeId === undefined).length === 0;
        },
    },
    methods: {
        async reload() {
            if (!this.entityTypeId || !this.entityId) {
                return;
            }
            this.grants = (await this.apiClient.getJson(`/api/v1/core/access-control/${this.entityTypeId}/${this.entityId}/grants`)).sort((a, b) => {
                if ((a.principalTypeId || '') < (b.principalTypeId || '')) return -1;
                if ((b.principalTypeId || '') < (a.principalTypeId || '')) return 1;
                const aRoleName = this.allRoles[a.principalId || ''] || '';
                const bRoleName = this.allRoles[b.principalId || ''] || '';
                if (aRoleName < bRoleName) return -1;
                if (bRoleName < aRoleName) return 1;
                return 0;
            });
        },
        addGrant(principalTypeId, principalId) {
            const grant = {
                principalTypeId,
                principalId,
                isAllowed: false,
            };
            this.grants.push(grant);
        },
        iconForPrincipalTypeId(principalTypeId) {
            if (principalTypeId === undefined) {
                return 'fal/question-square';
            }
            if (principalTypeId === null) {
                return 'fas/globe-americas';
            }
            switch (principalTypeId?.toLowerCase()) {
                case userEntityTypeId:
                    return 'fas/user';
                case roleEntityTypeId:
                    return 'fas/users';
                default:
                    return 'fal/question-square';
            }
        },
        nameForPrincipal(principalTypeId, principalId) {
            if (principalTypeId === undefined) {
                return 'Select...';
            }
            if (!principalTypeId) {
                return '(Anonymous Users)';
            }
            if (!principalId) {
                return '(Logged-In Users)';
            }
            return this.allRoles[principalId?.toLowerCase()]?.name || `{${principalId}}`;
        },
        ...mapActions('iam', ['loadRoles']),
    },
};
</script>